import { io } from 'socket.io-client';
import { useSelector, shallowEqual } from 'react-redux';
import { useEffect, useState } from 'react';
const useSocket = (id, setSocketIsConnected, setSocketMessage) => {
    const token = useSelector((store) => store?.auth?.userLogin?.response?.data?.accessToken, shallowEqual);
    const [socket, setSocket] = useState(null);
    useEffect(() => {
        if (token) {
            //@ts-ignore
            const socketInstance = io(BASE_URL_SOCKET, {
                transports: ['websocket', 'polling', 'flashsocket'],
                query: { token },
                reconnection: true,
                reconnectionAttempts: 100,
                reconnectionDelay: 2000,
            });
            socketInstance.on('connect', () => {
                // message.success('Connection established succesfully');
                setSocketMessage('Connection established succesfully');
                setTimeout(() => {
                    setSocketIsConnected(true);
                }, 2000);
            });
            socketInstance.on('connect_error', (error) => {
                setSocketIsConnected(false);
                setSocketMessage('Connection Lost.Trying to reconnect....');
            });
            socketInstance.on('connect_timeout', (timeout) => {
                setSocketIsConnected(false);
                setSocketMessage('Connection Lost.Trying to reconnect....');
            });
            socketInstance.on('error', (error) => {
                setSocketIsConnected(false);
                setSocketMessage('Connection Lost.Trying to reconnect....');
            });
            socketInstance.on('disconnect', (reason) => {
                setSocketIsConnected(false);
                setSocketMessage('Connection Lost.Trying to reconnect....');
            });
            //@ts-ignore
            setSocket(socketInstance);
            const handleReconnect = () => {
                if (!socketInstance.connected) {
                    console.log('Reconnecting socket after internet is available...');
                    socketInstance.connect();
                }
            };
            window.addEventListener('online', handleReconnect);
            return () => {
                socketInstance.disconnect();
                window.removeEventListener('online', handleReconnect);
            };
        }
    }, [token]);
    useEffect(() => {
        if (socket && id) {
            const subscribe = () => {
                const type = 'floor';
                const data = { id, type };
                const channel = `/topic/floor/${id}`;
                //@ts-ignore
                socket.emit('SUBSCRIBE', channel, data);
            };
            // Subscribe when the socket is connected or reconnected
            //@ts-ignore
            socket.on('connect', subscribe);
            // Initial subscription
            subscribe();
            return () => {
                //@ts-ignore
                socket.off('connect', subscribe);
            };
        }
    }, [socket, id]);
    return socket;
};
export default useSocket;
